import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SCHOLARSHIP_MANAGEMENT_FEATURE_KEY,
  ScholarshipManagementState,
  ScholarshipManagementPartialState,
  scholarshipManagementAdapter,
} from './scholarship-management.reducer';
import { ScholarshipManagementDto } from '@cradua/data';

// Lookup the 'ScholarshipManagement' feature state managed by NgRx
export const getScholarshipManagementState = createFeatureSelector<
  ScholarshipManagementPartialState,
  ScholarshipManagementState
>(SCHOLARSHIP_MANAGEMENT_FEATURE_KEY);

const {
  selectAll,
  selectEntities,
} = scholarshipManagementAdapter.getSelectors();

export const getScholarshipManagementLoaded = createSelector(
  getScholarshipManagementState,
  (state: ScholarshipManagementState) => state.loaded
);

export const getScholarshipManagementError = createSelector(
  getScholarshipManagementState,
  (state: ScholarshipManagementState) => state.error
);

export const loadingScholarshipManagement = createSelector(
  getScholarshipManagementState,
  (state: ScholarshipManagementState) => state.loaded
);

export const getAllScholarshipManagement = createSelector(
  getScholarshipManagementState,
  (state: ScholarshipManagementState) => selectAll(state)
);

export const getScholarshipManagementEntities = createSelector(
  getScholarshipManagementState,
  (state: ScholarshipManagementState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getScholarshipManagementState,
  (state: ScholarshipManagementState) => state.selectedScholarshipManagementId
);

export const getSelected = createSelector(
  getScholarshipManagementEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSearchStudentRecord = createSelector(
  getAllScholarshipManagement,
  getSelectedId,
  (users: ScholarshipManagementDto[], selectedId) => {
    if (selectedId === '.') {
      return users;
    }

    return !selectedId
      ? null
      : users.filter(
          (user) =>
            user.BeneficaryFirstname.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.BeneficaryOthername.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.BeneficarySurname.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.ContactEmail.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.ContactPhoneNo.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.PhoneNumber.toLowerCase().includes(
              String(selectedId).toLowerCase()
            )
        );
  }
);
